import { useQuery } from '@tanstack/react-query'
import ms from 'ms'

import useCurrentCompanyOrFail from '@/hooks/useCurrentCompanyOrFail'
import { QUERY_KEYS } from '@/lib/queryKeys'
import companyService from '@/lib/services/companyService'

export function useAdminUsers() {
  return useAdminUsersQuery().data?.['hydra:member'] || []
}

export function useAdminUsersQuery() {
  const currentCompany = useCurrentCompanyOrFail()

  return useQuery({
    queryKey: QUERY_KEYS.adminCompanyUsers(),
    queryFn: () => companyService.getAdminCompanyUsers(currentCompany.id),
    staleTime: ms('5m'),
  })
}
